import { ReactElement, useState } from 'react';
import {
  LineChart,
  Line,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  ResponsiveContainer,
} from 'recharts';

import styles from './MainChart.module.scss';

import CustomTooltip from '../../CustomTooltip/CustomTooltip';
import Options from '../../Options/Options';

interface ChartDataFormat {
  name: string;
  Views: number;
}

interface Props {
  lastWeekData: ChartDataFormat[];
  lastMonthData: ChartDataFormat[];
  lastYearData: ChartDataFormat[];
}

function MainChart({
  lastWeekData,
  lastMonthData,
  lastYearData,
}: Props): ReactElement {
  const [activeTab, setActiveTab] = useState('year');

  const getChartData = () => {
    if (activeTab === 'week') {
      return lastWeekData;
    }
    if (activeTab === 'month') {
      return lastMonthData;
    }
    return lastYearData;
  };

  return (
    <div className={styles.outer}>
      <Options
        isMain={true}
        activeTab={activeTab}
        setActiveTab={setActiveTab}
        options={['week', 'month', 'year']}
        data={getChartData()}
      />

      <div style={{ height: '300px' }}>
        <ResponsiveContainer>
          <LineChart
            width={500}
            height={300}
            data={getChartData()}
            margin={{
              top: 5,
              right: 0,
              left: 0,
              bottom: 5,
            }}
          >
            <CartesianGrid strokeDasharray="3 3" />
            <XAxis dataKey="name" axisLine={false} />
            <YAxis width={30} />
            <Tooltip content={<CustomTooltip />} />
            <Line
              type="monotone"
              dataKey="Views"
              stroke="#e544ff"
              activeDot={{ r: 8 }}
              strokeWidth={3}
            />
          </LineChart>
        </ResponsiveContainer>
      </div>
    </div>
  );
}

export default MainChart;
